import { createCameraVideoTrack, createMicrophoneAudioTrack } from "@videosdk.live/react-sdk";

const useMediaStream = () => {

  const getVideoTrack = async ({ webcamId, encoderConfig }) => {
    try {
      return await createCameraVideoTrack({
        cameraId: webcamId,
        encoderConfig: encoderConfig ? encoderConfig : "h540p_w960p",
        optimizationMode: "motion",
        multiStream: false,
      });
    } catch (error) {
      return null;
    }
  };

  const getAudioTrack = async ({ micId }) => {
    try {
      return await createMicrophoneAudioTrack({
        microphoneId: micId
      });
    } catch (error) {
      return null;
    }
  };

  return { getVideoTrack, getAudioTrack };
};

export default useMediaStream;
